import FieldConfig from "../../../proto/field-config"
import {
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan
} from "../../../../model2/conditions/condition-types"
import FieldCurrency from "../../../generic/finance/currency/currency";

// const debug = "FieldExpenseAmount"
const debug = false

export default class FieldExpenseAmount extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config)

        this.positiveOnly = true

        this.conditionTypes     = [
            ConditionType_NumberGreaterThan,
            ConditionType_NumberLessThan,
            ConditionType_NumberEquals
        ]
    }

    isValueValid(value: any): boolean {
        const numberValue = parseFloat(value)

        // value can't be empty
        if (_.isNil(numberValue) || numberValue === 0) {
            return false
        }

        return super.isValueValid(numberValue)
    }
}
